import { render, staticRenderFns } from "./RevisionsDialog.vue?vue&type=template&id=438baa90&scoped=true&"
import script from "./RevisionsDialog.vue?vue&type=script&lang=js&"
export * from "./RevisionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsDialog.vue?vue&type=style&index=0&id=438baa90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438baa90",
  null
  
)

export default component.exports